export class DemoModeWriteError extends Error {
  constructor() {
    super('Product demo mode does not allow write requests');
    this.name = 'DemoModeWriteError';
  }
}

export const isDemoModeWriteError = (
  error: unknown,
): error is DemoModeWriteError => error instanceof DemoModeWriteError;
